<template>
  <div class="min-h-screen flex flex-col items-center justify-center p-10">
    <div class="max-w-sm w-full text-left space-y-8">
      <div class="space-y-6">
        <div class="flex items-center justify-start space-x-4 mb-8">
          <img src="/3cnl/images/frame-logo-beta.svg" alt="3CNL Beta Logo" class="logo">
        </div>

        <p class="text-xl paragraph font-light">
          Transform your running data <br>into visuals worth sharing
        </p>

        <p class="text-md paragraph second-paragraph font-light">
          powered by <a href="https://3cnl.com"><Logo :width="100" color="#3C0F33" /></a>
        </p>

        <a
          class="inline-block mt-8 strava-button"
          href="/api/strava/redirect"
        >
          <img src="/3cnl/images/btn_strava_connectwith_orange.svg" alt="Connect with Strava">
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Logo from '#/shared/components/logo.vue';
import {
  stravaAthleteAtom,
  stravaAccessTokenAtom,
} from '#/entity/strava/strava-model';
import { reatomRef } from '@reatom/npm-vue';
import { navigate } from 'vike/client/router';
import { onMounted } from 'vue';

const stravaAthlete = reatomRef(stravaAthleteAtom);
const stravaAccessToken = reatomRef(stravaAccessTokenAtom);

onMounted(() => {
  if (stravaAthlete.value && stravaAccessToken.value) {
    navigate('/strava/activities');
  }
});
</script>

<style scoped>
.strava-button {
  border: none;
  display: inline-block;
}

.strava-button:hover {
  opacity: 0.8;
}

.logo {
  width: 200px;
}

.second-paragraph svg {
  width: 60px;
  display: inline;
  vertical-align: text-bottom;
  position: relative;
  top: 1px;
}

.paragraph {
  color: #3C0F33;
}
</style>
